'use client';

import 'bootstrap/dist/css/bootstrap.min.css';
import dynamic from 'next/dynamic';
import CacheBuster from 'react-cache-buster';
import useDeferredMount from '@/utils/useDeferredMount';

const CookieSetting = dynamic(
  () => import('cookiesetting-component').then((mod) => mod.CookieSetting),
  { ssr: false }
);

export default function Providers({ children }) {
  const readyForAnalytics = useDeferredMount();

  return (
    <>
      {children}
      {/* Sibling of children, not a wrapper: CacheBuster renders nothing until its own effect runs, which would blank the static export. */}
      <CacheBuster
        currentVersion={process.env.NEXT_PUBLIC_APP_VERSION}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={(process.env.NEXT_PUBLIC_PUBLIC_URL || process.env.NEXT_PUBLIC_BASENAME || '').replace(/\/+$/, '')}
      >
        {readyForAnalytics && (
          <CookieSetting
            privacyPolicyLink={process.env.NEXT_PUBLIC_PRIVACY_POLICY_LINK}
            configUrl={process.env.NEXT_PUBLIC_COOKIE_SETTING_JSON}
            analytics={process.env.NEXT_PUBLIC_ANALYTICS_PATH}
          />
        )}
      </CacheBuster>
    </>
  );
}
